import userService from "../../services/userService";
import { Button } from "react-bootstrap";

let version = require('../../../package.json').version

const Version = ({ }) => {

  const handleLogout = () => {
    userService.logout();
  }

  return (
    <div>
      <span
        style={{
          fontSize: "1.25rem",
          marginRight: "30px"
        }}
      >
        v{version}
      </span>
      <Button onClick={handleLogout}>Logout</Button>
    </div>
  );
}

export default Version